import { useQuery } from '@tanstack/react-query';
import { foldersApi } from '../lib/api';

export interface Folder {
  id: string;
  account_id: string;
  path: string;
  name: string;
  parent_path: string | null;
  special_use: string | null;
  total_count: number;
  unread_count: number;
}

export function useFolders(accountId?: string) {
  return useQuery({
    queryKey: ['folders', accountId ?? 'all'],
    queryFn: async () => {
      const res = await foldersApi.list(accountId);
      return (res?.folders ?? []) as Folder[];
    },
  });
}
